import { makeAutoObservable } from 'mobx';

import { Measurement, MeasurementSchema } from '../../../../../../typings/reality-capture/volumes/models';

export class MeasurementStore {
    measurements: Measurement[] = [];
    selectedMeasurementUuid = null;
    nextId = 1;
    visibleVolumeIndices: Set<string> = new Set();

    constructor() {
        makeAutoObservable(this);
    }

    addMeasurement(measurement: Omit<Measurement, 'id'>) {
        console.log('addMeasurementMobx', measurement);
        const parsed = MeasurementSchema.omit({ id: true }).parse(measurement);
        this.measurements.push({
            id: this.nextId,
            ...parsed,
        });
        this.setVolumeVisible(parsed.uuid, true);
        this.nextId += 1;
        return this.nextId - 1;
    }

    measurementExists(uuid: string): boolean {
        return this.measurements.some(measurement => measurement.uuid === uuid);
    }

    selectMeasurement(uuid: string) {
        this.selectedMeasurementUuid = uuid;
    }

    getSelectedMeasurement(): Measurement {
        return this.measurements.find(measurement => measurement.uuid === this.selectedMeasurementUuid);
    }

    updateMeasurement(measurement: Measurement) {
        const idx = this.measurements.findIndex(m => m.id === measurement.id);
        if (idx === -1) return;
        this.measurements[idx] = { ...measurement };
    }

    deleteMeasurement(uuid: string) {
        this.measurements = this.measurements.filter(measurement => measurement.uuid !== uuid);
        if (this.selectedMeasurementUuid === uuid) {
            this.selectedMeasurementUuid = null;
        }
        this.nextId -= 1;
    }

    clearMeasurements() {
        this.measurements = [];
        this.selectedMeasurementUuid = null;
        this.nextId = 1;
        this.visibleVolumeIndices.clear();
    }

    listVisibleMeasurements(): Measurement[] {
        return this.measurements.filter(m => this.visibleVolumeIndices.has(m.uuid));
    }

    setVolumeVisible(uuid: string, visible: boolean) {
        console.log('setVolumeVisible', uuid, visible);
        if (visible) {
            this.visibleVolumeIndices.add(uuid);
        } else this.visibleVolumeIndices.delete(uuid);
    }

    isVolumeVisible(uuid: string): boolean {
        return this.visibleVolumeIndices.has(uuid);
    }
}

export const measurementStore = new MeasurementStore();
